import {isMobile} from 'react-device-detect';

export const getStyle = (styleName) => {
  if (isMobile) {
    return styleName + '-mob';
  }

  return styleName;
};
